import { render, staticRenderFns } from "./CardStickyNotif.vue?vue&type=template&id=64320b4a&scoped=true"
import script from "./CardStickyNotif.vue?vue&type=script&lang=js"
export * from "./CardStickyNotif.vue?vue&type=script&lang=js"
import style0 from "./CardStickyNotif.vue?vue&type=style&index=0&id=64320b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64320b4a",
  null
  
)

export default component.exports